/* Klaviyo Back In Stock (first party).
   Works with snippets/klaviyo-bis.liquid. The widget markup and its variant
   availability data are server rendered inside the product section, so AJAX
   color swaps ship a fresh widget automatically. Every listener here is
   delegated on document, so nothing needs re-initializing after a swap. */
(function () {
  var REVISION = '2024-10-15';

  function widgetScope(widget) {
    return widget.closest('.shopify-section--main-product') || widget.closest('.shopify-section') || document;
  }

  function variantsFor(widget) {
    if (widget.__bisVariants) return widget.__bisVariants;
    var el = widget.querySelector('[data-bis-variants]');
    if (!el) return [];
    try { widget.__bisVariants = JSON.parse(el.textContent); } catch (e) { widget.__bisVariants = []; }
    return widget.__bisVariants;
  }

  function selectedVariant(widget) {
    var scope = widgetScope(widget);
    var variants = variantsFor(widget);
    if (!variants.length) return null;

    var opts = [];
    var i = 1;
    var input;
    while ((input = scope.querySelector('input[type="radio"][name="option' + i + '"]:checked'))) {
      opts.push(input.value);
      i++;
    }

    if (opts.length) {
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (String(variants[v].options[j] || '') !== String(opts[j] || '')) { ok = false; break; }
        }
        if (ok) return variants[v];
      }
    }

    var idInput = scope.querySelector('form[is="product-form"] input[name="id"], form.shopify-product-form input[name="id"]');
    if (idInput && idInput.value) {
      for (var k = 0; k < variants.length; k++) {
        if (String(variants[k].id) === String(idInput.value)) return variants[k];
      }
    }

    return null;
  }

  function syncWidget(widget) {
    var trigger = widget.querySelector('[data-bis-trigger]');
    if (!trigger) return;
    var variant = selectedVariant(widget);
    widget.__bisSelected = variant;
    trigger.hidden = !variant || variant.available !== false;
  }

  function syncAll() {
    document.querySelectorAll('[data-bis]').forEach(syncWidget);
  }

  /* Ancestor transforms inside the product section trap position:fixed and
     let the header paint over the modal. Portal it to <body> on first open. */
  function modalFor(widget) {
    if (widget.__bisModal && document.body.contains(widget.__bisModal)) return widget.__bisModal;
    var modal = widget.querySelector('[data-bis-modal]');
    if (modal) {
      document.querySelectorAll('body > [data-bis-modal]').forEach(function (m) { m.remove(); });
      document.body.appendChild(modal);
      modal.__bisWidget = widget;
      widget.__bisModal = modal;
    }
    return modal;
  }

  function widgetForNode(node) {
    var modal = node.closest('[data-bis-modal]');
    if (modal && modal.__bisWidget) return modal.__bisWidget;
    return node.closest('[data-bis]');
  }

  function openModal(widget) {
    syncWidget(widget);
    var variant = widget.__bisSelected;
    var modal = modalFor(widget);
    if (!modal || !variant) return;

    var label = modal.querySelector('[data-bis-variant-label]');
    if (label) label.textContent = variant.title || '';

    var formStep = modal.querySelector('[data-bis-step="form"]');
    var successStep = modal.querySelector('[data-bis-step="success"]');
    if (formStep) formStep.hidden = false;
    if (successStep) successStep.hidden = true;

    var err = modal.querySelector('[data-bis-error]');
    if (err) err.hidden = true;

    modal.hidden = false;
    document.documentElement.classList.add('bis-modal-open');

    var email = modal.querySelector('[data-bis-email]');
    if (email) setTimeout(function () { email.focus(); }, 50);
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.classList.remove('bis-modal-open');
  }

  function submitWidget(widget) {
    if (!widget) return;
    var modal = widget.__bisModal || widget.querySelector('[data-bis-modal]');
    if (!modal) return;

    var variant = widget.__bisSelected;
    var emailInput = modal.querySelector('[data-bis-email]');
    var err = modal.querySelector('[data-bis-error]');
    var btn = modal.querySelector('[data-bis-submit]');
    var email = ((emailInput && emailInput.value) || '').trim();

    if (!variant) return;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (err) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; }
      return;
    }

    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.__bisLabel = btn.textContent; btn.textContent = 'Submitting...'; }

    var company = widget.getAttribute('data-bis-company');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      /* Klaviyo's Cloudflare edge 403s this endpoint whenever a Referer is sent
         (no CORS header on the block page, so it surfaces as a network error). */
      referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } }
          }
        }
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.text().then(function (t) { throw new Error(t || String(res.status)); });
        }
        var formStep = modal.querySelector('[data-bis-step="form"]');
        var successStep = modal.querySelector('[data-bis-step="success"]');
        if (formStep) formStep.hidden = true;
        if (successStep) successStep.hidden = false;
      })
      .catch(function () {
        if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.__bisLabel || 'Notify Me When Available'; }
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bis-trigger]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.closest('[data-bis]'));
      return;
    }

    var closeEl = e.target.closest('[data-bis-close]');
    if (closeEl) {
      var modal = closeEl.closest('[data-bis-modal]');
      if (modal) closeModal(modal);
      return;
    }

    var submitBtn = e.target.closest('[data-bis-submit]');
    if (submitBtn) {
      e.preventDefault();
      submitWidget(widgetForNode(submitBtn));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('[data-bis-modal]:not([hidden])');
      if (open) closeModal(open);
      return;
    }
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-bis-email]')) {
      e.preventDefault();
      submitWidget(widgetForNode(e.target));
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[type="radio"][name^="option"]')) return;
    setTimeout(syncAll, 0);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  /* AJAX swaps replace the whole product section. The incoming HTML carries the
     server default selection; the swap code then re-applies the shopper's size
     via change events. Sync when a new widget lands so both paths are covered. */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('[data-bis]')) || (node.querySelector && node.querySelector('[data-bis]'))) {
          setTimeout(syncAll, 0);
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

